import type { ISyncBookkeepingRepository } from '@/domain/repositories/ISyncBookkeepingRepository';
import type { SyncBookkeeping } from '@/domain/entities/SyncBookkeeping';
import {
  SYNC_BOOKKEEPING_STORE,
  openActivationRuntimeDb,
  promisifyRequest,
} from '@/infrastructure/indexeddb/activationRuntimeDb';

/** Implementação de `ISyncBookkeepingRepository` sobre a object store
 * `syncBookkeeping` do IndexedDB (chave: `deviceId`) — CA-13. */
export class IndexedDbSyncBookkeepingRepository implements ISyncBookkeepingRepository {
  async get(deviceId: string): Promise<SyncBookkeeping | null> {
    const db = await openActivationRuntimeDb();
    try {
      const tx = db.transaction(SYNC_BOOKKEEPING_STORE, 'readonly');
      const result = await promisifyRequest<SyncBookkeeping | undefined>(
        tx.objectStore(SYNC_BOOKKEEPING_STORE).get(deviceId)
      );
      return result ?? null;
    } finally {
      db.close();
    }
  }

  async save(bookkeeping: SyncBookkeeping): Promise<void> {
    const db = await openActivationRuntimeDb();
    try {
      const tx = db.transaction(SYNC_BOOKKEEPING_STORE, 'readwrite');
      await promisifyRequest(tx.objectStore(SYNC_BOOKKEEPING_STORE).put(bookkeeping));
    } finally {
      db.close();
    }
  }
}
